module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0